<template>
  <div class="container-cidades">

      <div class="row mb-4 text-center">
     <div class="col">
    <router-link :to="`/locacao/${pasta}`">
      <img src="/img/ficha.png" alt="Ficha" class="icon-menu" /> </router-link>
      <p class="link-locacao">FICHA</p>
   
  </div>

  <div class="col">
    <router-link :to="`/boletos/${pasta}`">
      <img src="/img/boletos.png" alt="Boletos" class="icon-menu" />   </router-link>
      <p  class="link-locacao">BOLETOS</p>
 
  </div>

  <div class="col">
    <router-link :to="`/repasses/${pasta}`">
      <img src="/img/repasses.png" alt="Repasses" class="icon-menu" /> </router-link>
      <p  class="link-locacao">REPASSES</p>
   
  </div>

  <div class="col">
    <router-link :to="`/iptuClientes/${pasta}`">
      <img src="/img/iptu.png" alt="IPTU" class="icon-menu" /> </router-link>
      <p  class="link-locacao">IPTU</p>
   
  </div>
  <div class="col">
    <router-link :to="`/seguroFianca/${pasta}`">
      <img src="/img/seguro.png" alt="SEGURO" class="icon-menu" /> </router-link>
      <p  class="link-locacao">SEGURO</p>
   
  </div>


  <div class="col">
    <router-link :to="`/relatorios/${pasta}`">
      <img src="/img/relatorios.png" alt="Relatórios" class="icon-menu" /> </router-link>
      <p  class="link-locacao">RELATÓRIOS</p>
   
  </div>

    </div>
    
    <form class="row" method="POST" ref="formulario" @submit.prevent.stop="add">   
      <input type="hidden" name="acao" :value="acao"/>

      <!-- Cabeçalho -->
      <div class="col-sm-12 mb-3">
        <h3>Ficha de Locação</h3>
        <h5 v-if="acao==2"><strong>Pasta:</strong> {{ pasta }} | <strong>Referência do Imóvel:</strong> {{ referencia }} - <button @click="showImovel" type="button" role="button" class="btn btn-sm btn-warning">Visualizar</button></h5>
        <hr>
      </div>

      <!-- Dados do contrato -->
        <div class="form-group col-sm-1">
          <label>Pasta:</label>
          <input type="text" name="pasta" class="form-control" value="" v-model="pasta">
        </div>

        <div class="form-group col-sm-2">
          <label>Referência:</label>
          <input type="text" name="referencia" class="form-control" value="" v-model="referencia">
        </div>

      <div class="form-group col-sm-3">
        <label>Garantia:</label>
        <select class="form-control" name="garantia" v-model="garantia">
          <option value="">Nenhuma</option>
          <option value="Fiador">Fiador</option>
          <option value="Titulo">Titulo</option>
          <option value="Seguro">Seguro</option>
          <option value="Caução">Caução</option>
        </select>
      </div>

       <div class="form-group col-sm-2">
        <label>Índice de reajuste:</label>
        <select class="form-control" name="garantia" v-model="reajuste">
          <option value="">Nenhum</option>
          <option value="INPC">INPC</option>
          <option value="IPCA">IPCA</option>
          <option value="IGPM">IGPM</option>
          <option value="Outros">Outros</option>
        </select>
      </div>

      <div class="form-group col-sm-2">
        <label>Meses de contrato:</label>
        <input type="text" name="tempo" class="form-control" v-model="tempo">
      </div>

      <div class="form-group col-sm-2">
        <label>Dia vencimento:</label>
        <input type="text" name="dia" class="form-control" v-model="dia">
      </div>

      <div class="form-group col-sm-3">
        <label>Data Renovação:</label>
        <Datepicker show-clear-button placeholder="Data Renovação" v-model="renovacaoContrato" lang="pt-br" date-format="formato"/>
      </div>

       <div class="form-group col-sm-3">
        <label>Início do contrato:</label>
        <Datepicker show-clear-button placeholder="Data Início" v-model="selectedDate" lang="pt-br" date-format="formato"/>
      </div>

      <div class="form-group col-sm-3">
        <label>Término do contrato:</label>
        <input type="text" class="form-control" :value="fimContrato" readonly />
      </div>

       <div class="form-group col-sm-3">
        <label>Valor Aluguel:</label>
        <input type="text" name="valor" class="form-control" v-money="money" v-model.lazy="valor" />
      </div>

      <div class="form-group col-sm-1">
        <label>% Adm:</label>
        <input type="number" name="porcentagem" class="form-control" v-model="porcentagem">
      </div>

 <div class="form-group col-sm-2">
        <label>Valor Adm:</label>
        <input type="text" name="valor3" class="form-control" v-money="money" v-model.lazy="valorTaxa" readonly/>
      </div>

      <div class="form-group col-sm-2">
        <label>Valor Boleto:</label>
        <input type="text" name="valor2" class="form-control" v-money="money" v-model.lazy="valor2" />
      </div>

     

      <!-- NOVOS CAMPOS -->
      <div class="form-group col-sm-2">
        <label>Responsável:</label>
        <select class="form-control" name="garantia" v-model="responsavel">
          <option value="">Nenhum</option>
          <option value="Imobiliária">Imobiliária</option>
          <option value="Locatário">Locatário</option>
        </select>
      </div>
      <!--<div class="form-group col-sm-3">
        <label>Seguradora: seguro incêndio</label>
        <input type="text" name="seguradora" class="form-control" v-model="seguradora">
      </div> -->

      <div class="form-group col-sm-3">
        <label>Seguro Incêndio:</label>
        <Datepicker show-clear-button placeholder="Renovado até" v-model="renovadoAte" lang="pt-br" date-format="formato"/>
      </div>

      <div class="form-group col-sm-2">
        <label>Dias p/ renovação:</label>
         <input type="text" class="form-control" :value="diasRenovacaoCalc" :class="{ vencido: renovacaoVencida }" readonly />
      </div>

      
      <!-- FIM NOVOS CAMPOS -->

      <div class="w-100"></div>

      <!-- Dados Locador -->
     <div class="col-sm-6 mt-4">
  <h5>Dados do Locador</h5>

  <div class="form-group">
    <label>Nome:</label>
    <input type="text" v-model="locadorNome" class="form-control"/>
  </div>

  <div class="form-group">
    <label>Telefone 1: celular <a :href="whatsLink(locadorTelefone1)" target="_blank"><img style="widht:30px;height:30px;" src="/img/whatsapp.jpeg" class="img-fluid " v-if="locadorTelefone1 != ''"/></a></label>
    <input type="text" v-model="locadorTelefone1" class="form-control" v-mask="'##-#########'"/>
  </div>

  <div class="form-group">
    <label>Telefone 2:</label>
    <input type="text" v-model="locadorTelefone2" class="form-control" v-mask="'##-#########'"/>
  </div>

  <div class="form-group">
    <label>Email:</label>
    <input type="email" v-model="locadorEmail" class="form-control"/>
  </div>

  <div class="form-group">
    <label>CPF:</label>
    <input type="text" v-model="locadorCPF" class="form-control"/>
  </div>

  <div class="form-group">
    <label>Outras informações:</label>
    <textarea v-model="locadorObs" class="form-control"></textarea>
  </div>
</div>

      <!-- Dados Locatário -->
      <div class="col-sm-6 mt-4">
  <h5>Dados do Locatário</h5>

  <div class="form-group">
    <label>Nome:</label>
    <input type="text" v-model="locatarioNome" class="form-control"/>
  </div>

  <div class="form-group">
    <label>Telefone 1: celular   <a :href="whatsLink(locatarioTelefone1)" target="_blank"><img style="widht:30px;height:30px;" src="/img/whatsapp.jpeg" class="img-fluid " v-if="locatarioTelefone1 != ''"/></a></label>
    <input type="text" v-model="locatarioTelefone1" class="form-control" v-mask="'##-#########'"/>
  </div>

  <div class="form-group">
    <label>Telefone 2:</label>
    <input type="text" v-model="locatarioTelefone2" class="form-control" v-mask="'##-#########'"/>
  </div>

  <div class="form-group">
    <label>Email:</label>
    <input type="email" v-model="locatarioEmail" class="form-control"/>
  </div>

  <div class="form-group">
    <label>CPF:</label>
    <input type="text" v-model="locatarioCPF" class="form-control"/>
  </div>

  <div class="form-group">
    <label>Outras informações:</label>
    <textarea v-model="locatarioObs" class="form-control"></textarea>
  </div>
</div>

      <!-- Repasse -->
      <div class="col-sm-4 mt-4">
        <h5>Dados para repasse de valores</h5>
        <label>Chave PIX</label>
         <select  name="chavePix"  v-model="pix" class="form-control mb-2">
           <option value="CPF">CPF</option>
           <option value="E-MAIL">E-MAIL</option>
           <option value="TELEFONE">TELEFONE</option>
         </select>

        <input type="text" v-model="repasse" placeholder="Chave Pix" class="form-control">
      </div>

      <!-- Observações -->
      <div class="col-sm-12 mt-3">
        <label>Observações:</label>
        <textarea v-model="obs" class="form-control"></textarea>
      </div>

      <!-- Status -->
      <div v-if="showStatus" class="alert alert-info col-sm-12 mt-3" role="alert">
        Informações atualizadas com sucesso!
      </div>

      <!-- Botão -->
      <div class="col-sm-12 mt-3">
        <button @click="add()" type="button" class="btn btn-warning">SALVAR</button>
        <div v-if="loading" class="spinner-border ml-2" role="status"></div>
      </div>
    </form>

    <!-- Documentos -->
    <div v-show="showUploads" class="row mt-5">
      <div class="col-sm-12">
        <h4>Documentos da Locação</h4>
      </div>

      <div class="form-group col-sm-4">
        <label>Nome do Documento:</label>
        <input type="text" v-model="novoNomeDoc" class="form-control" placeholder="Ex: Contrato Assinado">
      </div>

      <div class="form-group col-sm-4">
        <label>Selecionar Arquivo:</label>
        <input type="file" ref="fileInput" class="form-control" @change="selecionarArquivo">
      </div>

      <div class="form-group col-sm-4 d-flex align-items-end">
        <button class="btn btn-success" @click="uploadDocumento">Enviar</button>
      </div>

      <div class="col-sm-12 mt-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Data</th>
              <th>Descrição</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="doc in documentos" :key="doc.DOC_ID">
              <td>{{doc.DOC_DATA || ''}}</td>
              <td>{{doc.DOC_NOME}}</td>
              <td>
                <a :href="'https://www2.royaljardim.com.br/sistema/uploads/' + doc.DOC_ARQUIVO" target="_blank" class="btn btn-sm btn-info">Visualizar</a>
                <button class="btn btn-sm btn-danger" @click="excluirDocumento(doc.DOC_ID)">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>


    <!--modal  -->

    <modal name="my-first-modal">
        <section class="p-3">
           <exibicaoImovel v-if="referencia != ''" :lead.sync="referencia"/>
        </section>
    </modal>
<!-- -->


  </div>
</template>
<style scoped>
label,h5,h4,h1,h2,h3{color:#4C1C17;font-weight:bold;}
.icon-menu {
  width: 80px;
  height: 80px;
}
.vencido {
  color: #dc3545;
  background: #ffe5e5;
  
}
</style>
<script>
import axios from 'axios'


export default {
  name: 'Locacao',
  components:{ ExibicaoImovel: () => import('@/components/ExibicaoImovel')},
  data(){
    return {
      reajuste:'',
      responsavel:'',
      acao: 1,
      pasta:'',
      referencia:'',
      garantia:'',
      tempo:'',
      dia:'',
      porcentagem:5,
      selectedDate:'',
      valor:'0,00',
      valor2:'3,80',
      valor3:'',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      loading:false,
      showStatus:false,
      showUploads:false,
      // Locador
      locadorNome:'',
      locadorTelefone1:'',
      locadorTelefone2:'',
      locadorEmail:'',
      locadorCPF:'',
      locadorObs:'',
      // Locatario
      locatarioNome:'',
      locatarioTelefone1:'',
      locatarioTelefone2:'',
      locatarioEmail:'',
      locatarioCPF:'',
      locatarioObs:'',
      // Repasse
      repasse:'',
      pix:'CPF',
      obs:'',
       seguradora:'',
      renovadoAte:'', // Date object
     renovacaoContrato:'',
      // Documentos
      documentos:[],
      novoNomeDoc:'',
      arquivoSelecionado:null,
    }
  },
  computed:{
    renovacaoVencida() {
    // vazio OU vencido
    return this.diasRenovacaoCalc == '' || this.diasRenovacaoCalc == 'Seguro vencido' || this.diasRenovacaoCalc == "0 dias";
  },
 diasRenovacaoCalc(){
    if(!this.renovadoAte) return "";
    let hoje = new Date();
    let renov = new Date(this.renovadoAte);

    // zerar horas para não dar diferença por fuso
    hoje.setHours(0,0,0,0);
    renov.setHours(0,0,0,0);

    let diff = renov - hoje; // diferença em ms
    let dias = Math.ceil(diff / (1000 * 60 * 60 * 24));

    return dias >= 0 ? dias + " dias" : "Seguro vencido";
  },
    valorTaxa(){
      let v = parseFloat(this.valor.replace("R$", "").trim().replace(/\./g, "").replace(",", "."));
      if(isNaN(v)) v = 0;
      let retorno = (this.porcentagem/100) * v;
      return retorno.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
    },
    fimContrato(){
    
      if(this.selectedDate && this.tempo && this.renovacaoContrato == ''){
        let fim = new Date(this.selectedDate);
        fim.setMonth(fim.getMonth() + Number(this.tempo));
        return fim.toLocaleDateString("pt-BR");
      }

       if(this.renovacaoContrato && this.tempo){
        let fim = new Date(this.renovacaoContrato);
        fim.setMonth(fim.getMonth() + Number(this.tempo));
        return fim.toLocaleDateString("pt-BR");
      }

      return "";
    }
  },
  methods:{
     showImovel(){
            this.$modal.show('my-first-modal');
        },

    whatsLink(num){
    if(!num) return '#';
    // remove tudo que não for número
    let digits = num.replace(/\D/g, '');
    // adiciona DDI do Brasil se tiver só DDD+numero
    if(digits.length === 10 || digits.length === 11){
      digits = '55' + digits;
    }
    return `https://wa.me/${digits}`;
  },
     filtrar(dinheiro){
      return dinheiro.replace('R$', "").replace('.', "").replace('.', "").replace(',', ".").trim();
    },
    selecionarArquivo(e){ this.arquivoSelecionado = e.target.files[0]; },
    uploadDocumento(){
      if(!this.arquivoSelecionado || !this.novoNomeDoc){
        alert("Selecione um arquivo e informe um nome.");
        return;
      }
      let formData = new FormData();
      formData.append("pasta", this.pasta);
      formData.append("nome", this.novoNomeDoc);
      formData.append("arquivo", this.arquivoSelecionado);
      axios.post("https://www2.royaljardim.com.br/sistema/locacao/uploadDocumento", formData, {
        headers:{'Content-Type':'multipart/form-data'}
      }).then(()=>{this.getDocumentos();this.novoNomeDoc='';this.$refs.fileInput.value='';})
    },
    getDocumentos(){
      axios.post("https://www2.royaljardim.com.br/sistema/locacao/getDocumentos",{pasta:this.pasta})
        .then(res=>this.documentos=res.data);
    },
    excluirDocumento(id){
      if(confirm("Deseja excluir este documento?")){
        axios.post("https://www2.royaljardim.com.br/sistema/locacao/deleteDocumento",{id:id})
          .then(()=>this.getDocumentos());
      }
    },
    add(){
      this.loading = true;
      let formData = new FormData(this.$refs["formulario"]);
      formData.append('corretor',this.getUsuario());
           formData.append('valor',this.filtrar(this.valor));
           formData.append('valor2',this.filtrar(this.valor2));
           formData.append('valor3',this.filtrar(this.valorTaxa));
           // Identificação
  formData.append('pasta', this.pasta);
  formData.append('referencia', this.referencia);

    // Contrato
  formData.append('garantia', this.garantia);
  formData.append('seguradora', this.seguradora);
  formData.append('tempo', this.tempo);
  formData.append('dia', this.dia);
  formData.append('porcentagem', this.porcentagem);
  formData.append('reajuste', this.reajuste);
  formData.append('responsavel', this.responsavel);
  // Locador
  formData.append('locadorNome', this.locadorNome);
  formData.append('locadorTelefone1', this.locadorTelefone1);
  formData.append('locadorTelefone2', this.locadorTelefone2);
  formData.append('locadorEmail', this.locadorEmail);
  formData.append('locadorCPF', this.locadorCPF);
  formData.append('locadorObs', this.locadorObs);

  // Locatário
  formData.append('locatarioNome', this.locatarioNome);
  formData.append('locatarioTelefone1', this.locatarioTelefone1);
  formData.append('locatarioTelefone2', this.locatarioTelefone2);
  formData.append('locatarioEmail', this.locatarioEmail);
  formData.append('locatarioCPF', this.locatarioCPF);
  formData.append('locatarioObs', this.locatarioObs);
  // Repasse / PIX
  formData.append('repasse', this.repasse);
  formData.append('pix', this.pix);

  // Observações gerais
  formData.append('obs', this.obs);


      if(this.selectedDate){
        let d = new Date(this.selectedDate);
        let dd = String(d.getDate()).padStart(2,'0');
        let mm = String(d.getMonth()+1).padStart(2,'0');
        let inicio = d.getFullYear()+"-"+mm+"-"+dd+" 00:00";
        formData.append('dataInicio',inicio);
      }
       if(this.renovadoAte){
        let r = new Date(this.renovadoAte);
        let dd = String(r.getDate()).padStart(2,'0');
        let mm = String(r.getMonth()+1).padStart(2,'0');
        let renov = r.getFullYear()+"-"+mm+"-"+dd+" 00:00";
        formData.append('renovadoAte', renov);
      }

      if(this.renovacaoContrato){
        let r = new Date(this.renovacaoContrato);
        let dd = String(r.getDate()).padStart(2,'0');
        let mm = String(r.getMonth()+1).padStart(2,'0');
        let renov = r.getFullYear()+"-"+mm+"-"+dd+" 00:00";
        formData.append('renovacaoContrato', renov);
      }
   

      axios.post('https://www2.royaljardim.com.br/sistema/locacao/criar',formData)
        .then((res)=>{console.log(res.data);this.loading=false;this.showStatus=true;this.showUploads=true;this.acao = 2;})
    },
    get(){
      axios.post('https://www2.royaljardim.com.br/sistema/locacao/getLocacao',{pasta:this.pasta})
        .then(r=>this.updateInfo(r.data))
    },
    updateInfo(data){
        this.pasta=data.LOC_PASTA||'';
      this.referencia=data.LOC_IMOVEL||'';
      this.garantia=data.LOC_GARANTIA||'';
       this.reajuste=data.LOC_REAJUSTE||'';
         this.responsavel=data.LOC_RESPONSAVEL||'';
      this.tempo=data.LOC_TEMPO_CONTRATO||'';
      this.dia=data.LOC_VENCIMENTO||'';
      this.porcentagem=data.LOC_PORCENTAGEM||0;
      this.valor=data.LOC_ALUGUEL||'0,00';
      this.valor2=data.LOC_BOLETO||'0,00';
      this.valor3=data.LOC_VALOR_ADM||'';
      this.locadorNome=data.LOC_LOCADOR||'';
      this.locatarioNome=data.LOC_LOCATARIO||'';
      this.locadorEmail=data.LOC_LOCADOR_EMAIL||'';
      this.locatarioEmail=data.LOC_EMAIL_LOCATARIO||'';
      this.pix=data.LOC_PIX||'';
      this.obs=data.LOC_OBSERVACAO||'';
      this.locadorTelefone1 = data.LOC_LOCADOR_TELEFONE1 || '';
      this.locadorTelefone2 = data.LOC_LOCADOR_TELEFONE2 || '';
      this.locadorCPF = data.LOC_LOCADOR_CPF || '';
      this.locadorObs = data.LOC_LOCADOR_OBS || '';
      this.locatarioTelefone1 = data.LOC_LOCATARIO_TELEFONE1 || '';
      this.locatarioTelefone2 = data.LOC_LOCATARIO_TELEFONE2 || '';
      this.locatarioCPF = data.LOC_LOCATARIO_CPF || '';
      this.locatarioObs = data.LOC_LOCATARIO_OBS || '';
       this.acao = 2;
      // NOVOS CAMPOS (seguradora / renovado / dias)
      this.seguradora = data.LOC_SEGURADORA || '';
       this.repasse = data.LOC_REPASSE || '';
     
      if(data.LOC_RENOVADO_ATE){
        // parse seguro: usar parte Y-M-D e construir Date local
        let ymd = data.LOC_RENOVADO_ATE.split(" ")[0];
        let parts = ymd.split("-");
        if(parts.length === 3){
          this.renovadoAte = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        } else {
          // fallback: tentativa direta
          let d = new Date(data.LOC_RENOVADO_ATE);
          d.setDate(d.getDate() + 1);
          this.renovadoAte = d;
        }
      } else {
        this.renovadoAte = '';
      }

      //////
   if(data.LOC_RENOVACAOCONTRATO){
        // parse seguro: usar parte Y-M-D e construir Date local
        let ymd = data.LOC_RENOVACAOCONTRATO.split(" ")[0];
        let parts = ymd.split("-");
        if(parts.length === 3){
          this.renovacaoContrato = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        } else {
          // fallback: tentativa direta
          let d = new Date(data.LOC_RENOVACAOCONTRATO);
          d.setDate(d.getDate() + 1);
          this.renovacaoContrato = d;
        }
      } else {
        this.renovacaoContrato = '';
      }
      ////

      if(data.LOC_INICIO_CONTRATO){
        let d = new Date(data.LOC_INICIO_CONTRATO);
        d.setDate(d.getDate()+1);
        this.selectedDate=d;
      }
      this.showUploads=true;
      this.getDocumentos();
    },
      getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
     getUsuarioID(){
       return sessionStorage.getItem('imobiliariaID');
     },
     getPermissao(){
       return sessionStorage.getItem('imobiliaria');
     }
  },
  mounted(){
    if(this.$route.params.id){
      this.pasta=this.$route.params.id;
      this.get();
    }
  }
}
</script>